import { render, staticRenderFns } from "./step-signature-pending.vue?vue&type=template&id=7cb70997&"
import script from "./step-signature-pending.vue?vue&type=script&lang=js&"
export * from "./step-signature-pending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports